export enum MppAttachmentOriginType {
  MANUAL_UPLOAD = 'manual_upload',
  UNSPLASH = 'unsplash',
  SHOOT_IN = 'shootin',
  CRAWLED = 'crawled',
  PEXELS = 'pexels',
  STUDIO = 'studio',
}
